<template lang="pug">
div.switch-element.l-flex-row--between(:class="[{'ui-disabled': isLoading || isDisabled}, {'is-active': isActive}, {'l-flex-row--between': !noFlexBetween}]")
    //- Overlay
    div.overlay-close_light(v-if="displaySingleEdit" @click="closeForm()")
    //- Single edit
    div.edit-single-wrapper(v-if="displaySingleEdit")
        input.edit-single-input(
            type="text"
            id="label"
            name="label"
            ref="label"
            v-model="editableLabel"
            v-validate="'min:3|max:200|ascii|required'"
            @keyup.enter="handleEditLabel()"
            @keyup.esc="closeForm()")
        span.form-validate-error {{ errors.first('label') }}

    svg-icon.edit-action(v-if="isEditable" name='edit' size='small' @click.native="displayForm()")
    label(v-if="isEditable &&!displaySingleEdit" :for="`switch-${inputName}-${currentKey}`") {{ label }}
    label(v-else-if="!displaySingleEdit" :for="`switch-${inputName}-${currentKey}`") {{ label }}

    div.onoffswitch(:key="type" :class="{'ui-disabled': displaySingleEdit }")
        input(
            :id="`switch-${inputName}-${currentKey}`"
            :name="`switch-${inputName}-${currentKey}`"
            class="onoffswitch-checkbox"
            @change.stop="updateValue()"
            v-model="isActive"
            type="checkbox")
        label(class="onoffswitch-label" :for="`switch-${inputName}-${currentKey}`")
</template>

<script>
import { createNamespacedHelpers, mapActions, mapMutations } from 'vuex'
const { mapState } = createNamespacedHelpers('ui/settings')

import { SETTINGS } from '@/utils/constants'
import { cloneDeep, includes } from 'lodash'

export default {
    name: 'SwitchItem',
    props: {
        label: { type: String, required: true },
        type: { type: String, required: false, default: '' },
        inputName: { type: String, required: true },
        isDisabled: { type: Boolean, required: false },
        isSwitchActive: { type: Boolean, required: true },
        loadData: { type: Function, required: false, default: () => ({}) },
        isEditable: { type: Boolean, required: false },
        editLabel: { type: Function, required: false, default: () => ({}) },
        fullData: { type: Object, required: false, default: () => ({}) },
        noFlexBetween: { type: Boolean, required: false },
        parent: { type: String, required: false }
    },
    watch: {
        isSwitchActive: function(newValue) {
            this.isActive = newValue
        },
        label: function(newValue) {
            this.editableLabel = newValue
        }
    },
    data() {
        return {
            isActive: this.isSwitchActive,
            currentKey: this.$vnode.key,
            displaySingleEdit: false,
            editableLabel: this.label
        }
    },
    computed: {
        ...mapState({
            isLoading: state => state.isLoading
        })
    },
    methods: {
        ...mapActions('ui/settings', ['updateStoreSetting']),
        ...mapActions('data/settings', ['updateTaxoLabel', 'updateExtraTaxoAction']),
        ...mapMutations('ui/settings', ['setDisplayModal', 'setIsLoading']),
        closeForm() {
            this.resetLabel()
            this.$emit('editLabel', false)
            this.displaySingleEdit = false
        },
        updateValue() {
            if (this.type && includes(SETTINGS, this.type)) {
                if (this.type !== 'dataMining' && this.type !== 'wamFactory') this.setIsLoading(true)
                this.updateStoreSetting({ type: this.type, name: this.inputName, activate: this.isActive })
                if (this.type === 'dataMining' && this.inputName === 'datamining' && !this.isActive) this.setDisplayModal({ display: true })
            } else if (this.inputName === 'pixelUrlRandom') {
                this.loadData(this.currentKey, this.type, this.inputName, this.isActive)
            } else if (this.type === 'extraTaxo') {
                const taxo = cloneDeep(this.fullData)
                this.updateExtraTaxoAction({ taxoToUpdate: taxo, status: taxo.status === 'active' ? 'inactive' : 'active' })
                this.$emit('taxoUpdated')
            } else if (this.type === 'businessApp') {
                this.$emit('businessAppUpdated', this.fullData.id)
            } else {
                this.loadData(this.inputName, this.isActive)
            }

            this.$emit('change', this.isActive)
        },
        displayForm() {
            this.$emit('editLabel', true)
            this.displaySingleEdit = true
            // this will set the focus into the input automatically
            this.$nextTick(() => this.$refs.label.focus())
        },
        resetLabel(){
            if (this.errors.has('label') || (this.parent === 'extraTaxo' && this.editableLabel.length < 3)) {
                this.editableLabel = this.label
            }
        },
        handleEditLabel() {
            if (this.errors.has('label') || (this.parent === 'extraTaxo' && this.editableLabel.length < 3)) return
            this.updateTaxoLabel({
                newLabel: this.editableLabel,
                currentStatus: this.isActive ? 'active' : 'inactive',
                taxo: cloneDeep(this.fullData)
            })
            this.closeForm()
            this.$emit('taxoLabelUpdated')
        }
    }
}
</script>
<style lang="scss" scoped>
.switch-element {
    position: relative;
    label {
        flex: 1;
    }
    &:hover {
        .edit-action {
            opacity: 1;
        }
    }
}
.edit-action {
    position: absolute;
    left: -24px;
    top: 1px;
    opacity: 0;
    &.is-edited {
        opacity: 1;
        fill: color('accent');
    }
}
.is-active {
    color: color('text');
}
.edit-single-wrapper {
    padding: 0;
    background-color: color('background');
    box-shadow: none;
    max-width: 260px;
}
.edit-single-input {
    border: none;
    border-bottom: 1px dotted color('separator');
    max-width: 260px;
}
</style>
